import React from "react";
import Card from "../../components/UI/card/card.component";

const NotFound = () => {
  return <Card>Page Not Found... :/</Card>;
};

export default NotFound;
